import React from 'react';
import NumberFormat from 'react-number-format';

export const FormInputNumber = ({ field, form: { touched, errors, setFieldValue }, ...props }) => {
  const {
    col,
    label,
    onValueChange,
    onFloatChange,
    suffix,
    prefix,
    allowNegative = true,
    disabled = false,
    precision,
    allowLeadingZeros = true,
    fixedDecimalScale,
    isAllowed,
    type = '',
    title,
  } = props;

  return (
    <div className={`col-lg-${col}`}>
      <div className={`form-group ${errors[field.name] ? 'has-error' : ''}`}>
        {label && (
          <label style={{ fontWeight: 'bold' }}>
            {label}
            {title && (
              <i
                className="fa fa-question-circle"
                title={title}
                data-toggle="tooltip"
                data-placement="top"
              />
            )}
          </label>
        )}

        <NumberFormat
          className="form-control required"
          value={field.value !== undefined && field.value !== null ? field.value : ''}
          allowNegative={allowNegative}
          suffix={suffix}
          prefix={prefix}
          type={type}
          thousandSeparator="."
          decimalSeparator=","
          disabled={disabled}
          decimalScale={precision}
          allowLeadingZeros={allowLeadingZeros}
          fixedDecimalScale={fixedDecimalScale ?? true}
          isAllowed={isAllowed}
          {...props}
          onValueChange={({ floatValue }) => {
            const safeValue = floatValue ?? 0;
            setFieldValue(field.name, safeValue);
            if (onValueChange) onValueChange(safeValue);
            if (onFloatChange) onFloatChange(safeValue);
          }}
        />

        {touched[field.name] && errors[field.name] && (
          <span className="help-block m-b-none">{errors[field.name]}</span>
        )}
      </div>
    </div>
  );
};
